import { useEffect, useState } from "react";

export const useInactivityTracker = (
  pageTitle,
  productCode,
  shouldTrackUsage,
  inactivityThreshold = 600000
) => {
  const [isTracking, setIsTracking] = useState(true);
  const [isInactive, setIsInactive] = useState(false);
  useEffect(() => {
    if (!pageTitle || !productCode || productCode === "dhe" || !isTracking) {
      return undefined;
    }
    if (!shouldTrackUsage) {
      setIsTracking(false);
      return undefined;
    }

    const inactivityTimerInterval = inactivityThreshold / 10;
    let startTime = Date.now();
    let userInactivityTimer = Date.now();
    const interval = setInterval(() => {
      userInactivityTimer = Date.now();
      const inactivityCheck =
        userInactivityTimer - startTime > inactivityThreshold;
      setIsInactive(inactivityCheck);
      setIsTracking(!inactivityCheck);
    }, inactivityTimerInterval);

    const handleScroll = () => {
      startTime = Date.now();
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearInterval(interval);
    };
  }, [
    pageTitle,
    productCode,
    isTracking,
    isInactive,
    inactivityThreshold,
    shouldTrackUsage,
  ]);

  return { isTracking, setIsTracking, isInactive, setIsInactive };
};
